import { getEnvConfig } from '@twisto/base/env-config'

import type { RequestWithHeaders } from './request'
import { getHeader } from './request'

const DEFAULT_REGION: GLOBALS.Region = 'CZ'

/**
 * Resolves the region from the host the page was requested for.
 *
 * Returns `undefined` when there is no request (static generation, client-side
 * navigation) so the caller can fall back to the client-side `envConfig`,
 * which derives the region from `window.location.host`.
 */
export const getRegionFromRequest = (
  req?: RequestWithHeaders
): GLOBALS.Region | undefined => {
  if (!req) {
    return undefined
  }

  const host = getHeader(req, 'x-forwarded-host') ?? req.headers.host

  if (!host) {
    return DEFAULT_REGION
  }

  try {
    return getEnvConfig(host).region
  } catch {
    // A malformed host header must not turn region resolution into a 500.
    return DEFAULT_REGION
  }
}
